import Repository from "@/plugins/axios";

export default {
  // Получить информацию для посетителей
  getVisitors() {
    return Repository.get(`/biennale/visitors`);
  },
};
